import React from 'react';
import { BadgeProps } from '../../../types';
import './Badge.css';

const Badge: React.FC<BadgeProps> = ({
  text,
  variant = 'primary',
  className = ''
}) => {
  const badgeClasses = `badge badge-${variant} ${className}`.trim();
  
  return (
    <span className={badgeClasses}>
      {text}
    </span>
  );
};

export default Badge;
